// Data for the important links page.
export const importantLinks = [
    {
      id: 1301,
      category: 'Community & Social',
      name: 'Aero DAMP Instagram Page',
      description: 'Follow the official Aerospace Engineering DAMP for updates and events.',
      url: 'https://www.instagram.com/aero_damp_iitb' // Replace with actual URL
    },
    {
      id: 1302,
      category: 'Academic Resources',
      name: 'PYQ Drive',
      description: 'Access a repository of previous years\' question papers for all courses.',
      url: 'https://drive.google.com/drive/folders/1KC9JggB3JIoaYYnTymsD8v6iIJiV0Oa9' // Replace with actual URL
    },
    {
      id: 1303,
      category: 'Academic Resources',
      name: 'Aero Academic Website',
      description: 'The official academic website for the Department of Aerospace Engineering.',
      url: 'https://www.aero.iitb.ac.in' // Replace with actual URL
    },
    {
      id: 1304,
      category: 'Career Resources',
      name: 'Resume Drive',
      description: 'A collection of anonymized resumes to help you build your own.',
      url: 'https://drive.google.com/drive/folders/1F1zBgBJDh9rBW1EqPwD-j7sSUXnBFs-G?usp=sharing' // Replace with actual URL
    },
  ];
  